import Image from 'next/image';
import dynamic from 'next/dynamic';
import type { ComponentsBullet } from 'queries/graphql';
import { useTextFontOverrides } from 'utils/font-override';
import { buildCssVar } from 'utils/style-override';

import styles from './styles.module.scss';

const MarkdownText = dynamic(() => import('generic/MarkdownText'));

export default function Bullet({ text, icon, style }: ComponentsBullet) {
  const { textColor, textFont } = style || {};

  const textFontOverrides = useTextFontOverrides(textFont);

  return (
    <div className={`root ${styles.container}`}>
      <style jsx>{`
        .root {
          ${buildCssVar('--text-color', textColor, 'var(--text-color-dark)')}
          ${textFontOverrides ?? ''}
        }
      `}</style>

      <div className={styles.bullet_container}>
        <div className={styles.img_wrapper}>
          {icon ? (
            <Image
              src={icon.src}
              alt="Bullet point"
              sizes="16px"
              width={16}
              height={16}
              // This allows us to serve SVG's
              unoptimized
            />
          ) : (
            <Image src="/bullet-tick.png" alt="Bullet option" sizes="16px" width={16} height={16} />
          )}
        </div>
        <div className={styles.text}>
          <MarkdownText text={text} />
        </div>
      </div>
    </div>
  );
}
